export default "/images/vendor/flag-icons/flags/1x1/sz.svg?58f78f9c3b487d3fc661426d4ab95d69";